import { useParams } from "react-router-dom";
import { useApi } from "../../../../../hooks/useApi";
import DefaultModalLayout, {
  ModalFixedBox,
} from "../../../../Modal/DefaultModalLayout";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";

interface Props extends DefaultModalCommonProps {
  uid: number;
}

export default function InviteLinkModal({ closeEvent, uid }: Props) {
  const { partyId } = useParams();

  const { response } = useApi({
    method: "get",
    url: uid > 0 ? `party/${partyId}/reglink/${uid}` : undefined,
  });

  const linkValue = response?.data?.reglink?.length > 0;

  return (
    <DefaultModalLayout
      modalTitle="초대 링크 보기"
      isSmallModal={true}
      closeEvent={() => closeEvent()}
      confirmEvent={() => closeEvent()}
      cancelBtn={<></>}
      confirmBtnText="닫기"
    >
      <ModalRow>
        <ModalLabel>초대 링크</ModalLabel>

        <ModalRowContentContainer>
          <ModalFixedBox
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={
              linkValue ? () => window.open(response?.data?.reglink) : undefined
            }
          >
            {linkValue ? response?.data?.reglink : "-"}
          </ModalFixedBox>
        </ModalRowContentContainer>
      </ModalRow>

      <ModalRow>
        <ModalLabel>등록 일시</ModalLabel>

        <ModalRowContentContainer>
          <ModalFixedBox>{response?.data?.logdate}</ModalFixedBox>
        </ModalRowContentContainer>
      </ModalRow>
    </DefaultModalLayout>
  );
}
